import { Injectable } from '@angular/core';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

@Injectable({
  providedIn: 'root'
})
export class PdfExportService {

  constructor() { }

  public captureAndExportPDF(element: HTMLElement, fileName: string = 'Report.pdf'): void {
    if (element) {
      // Add a small delay to ensure all dynamic content is rendered
      setTimeout(() => {
        html2canvas(element, {
          scale: 2,
          useCORS: true,
          allowTaint: true,
          logging: false,
          onclone: (clonedDoc) => {
            // Ensure all dynamic content is visible in the cloned document
            const badges = clonedDoc.getElementsByClassName('risk-badge');
            Array.from(badges).forEach((badge: HTMLElement) => {
              badge.style.display = 'block';
              badge.style.visibility = 'visible';
            });
          }
        }).then(canvas => {
          const imgData = canvas.toDataURL('image/png');
          const pdf = new jsPDF('p', 'mm', 'a4');
          const pdfWidth = pdf.internal.pageSize.getWidth();
          const pdfHeight = pdf.internal.pageSize.getHeight();

          // Calculate the image height in PDF units
          const imgProps = pdf.getImageProperties(imgData);
          const imgHeight = (imgProps.height * pdfWidth) / imgProps.width;

          let heightLeft = imgHeight;
          let position = 0;

          // Add the first page
          pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, imgHeight);
          heightLeft -= pdfHeight;

          // Add more pages if needed
          while (heightLeft > 0) {
            position = heightLeft - imgHeight;
            pdf.addPage();
            pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, imgHeight);
            heightLeft -= pdfHeight;
          }

          pdf.save(fileName);
        }).catch(error => {
          console.error('Could not capture the element to export as PDF', error);
        });
      }, 100); // 100ms delay to ensure content is rendered
    } else {
      console.error('Element not found.');
    }
  }
}
